/**
 * @flow
 * @relayHash c63c59768277b0f37b8cf41a34265f9e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgDailyImageInput = {|
  userId: string,
  category?: ?string,
  clientMutationId?: ?string,
|};
export type SetBackgroundDailyImageMutationVariables = {|
  input: SetUserBkgDailyImageInput
|};
export type SetBackgroundDailyImageMutationResponse = {|
  +setUserBkgDailyImage: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +backgroundImage: ?{|
        +id: string,
        +imageURL: ?string,
        +timestamp: ?string,
      |},
    |}
  |}
|};
export type SetBackgroundDailyImageMutation = {|
  variables: SetBackgroundDailyImageMutationVariables,
  response: SetBackgroundDailyImageMutationResponse,
|};
*/


/*
mutation SetBackgroundDailyImageMutation(
  $input: SetUserBkgDailyImageInput!
) {
  setUserBkgDailyImage(input: $input) {
    user {
      backgroundOption
      backgroundImage {
        id
        imageURL
        timestamp
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgDailyImageInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "backgroundOption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "backgroundImage",
  "storageKey": null,
  "args": null,
  "concreteType": "BackgroundImage",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SetBackgroundDailyImageMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgDailyImage",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetUserBkgDailyImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetBackgroundDailyImageMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgDailyImage",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "SetUserBkgDailyImagePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "SetBackgroundDailyImageMutation",
    "id": null,
    "text": "mutation SetBackgroundDailyImageMutation(\n  $input: SetUserBkgDailyImageInput!\n) {\n  setUserBkgDailyImage(input: $input) {\n    user {\n      backgroundOption\n      backgroundImage {\n        id\n        imageURL\n        timestamp\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '50f99e8a8c2ce7d300f7a57c4a15371f';
module.exports = node;
